import React from 'react';
import missionImg from '../assests/img/elevate-mission.jpg';
import visionImg from '../assests/img/elevate-vision.jpg';
import philosophyImg from '../assests/img/elevate-philosophy.jpg';
import strategyImg from '../assests/img/elevate-strategy.jpg';

const valueCards = [
  { title: 'Our Mission', image: missionImg },
  { title: 'Our Vision', image: visionImg },
  { title: 'Our Philosophy', image: philosophyImg },
  { title: 'Our Strategy', image: strategyImg },
];

function ElevateBusiness() {
  return (
    <section className="ma-elevate" aria-labelledby="elevate-business-title">
      <div className="ma-elevate-bg" aria-hidden="true">
        <span className="ma-elevate-glow ma-elevate-glow--left" />
        <span className="ma-elevate-glow ma-elevate-glow--right" />
      </div>

      <div className="ma-container ma-elevate-inner">
        <div className="ma-elevate-content">
          <span className="ma-elevate-label">Premier B2B Platform</span>
          <h2 id="elevate-business-title" className="ma-elevate-title">
            Elevate Your Business at the Premier B2B Mobile &amp; Accessories Gathering
          </h2>
          <p className="ma-elevate-text">
            Welcome to the ultimate convergence of innovation, trade, and networking. Our
            upcoming expo is meticulously designed to be the definitive platform for
            manufacturers, retailers, and distributors within the mobile technology
            ecosystem. This isn&apos;t just an event; it&apos;s where the future of the industry
            connects.
          </p>
        </div>

        <div className="ma-elevate-grid">
          {valueCards.map((card, index) => (
            <article
              key={card.title}
              className="ma-elevate-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <img className="ma-elevate-card-img" src={card.image} alt={card.title} />
              <div className="ma-elevate-card-overlay" aria-hidden="true" />
              <span className="ma-elevate-card-accent" aria-hidden="true" />
              <h3 className="ma-elevate-card-title">{card.title}</h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ElevateBusiness;
